import { render, staticRenderFns } from "./PopupLayout.vue?vue&type=template&id=5c208ef8&scoped=true&"
import script from "./PopupLayout.vue?vue&type=script&lang=ts&"
export * from "./PopupLayout.vue?vue&type=script&lang=ts&"
import style0 from "./PopupLayout.vue?vue&type=style&index=0&id=5c208ef8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c208ef8",
  null
  
)

export default component.exports